<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IU4qeZ/images/e9781439614785_cover.jpg?1684305842218" alt="This image is the cover for the book Chicago Boxing, Images of Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chicago Boxing, Images of Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>Professor Mike Donovan, Battling Nelson�"The Durable Dane," and "Stockyards" Harold Smith� their stories are as colorful as their names. Chicago�s boxing history is as exciting and unpredictable as any prize fight within the ring. Some of the most memorable bouts�great, infamous or otherwise�took place in the city�s clubs, parks and arenas, and Chicago has seen its share of champions and top contenders over the years. The Gans-McGovern fight in 1900�the "Big Fix"�set the sport back 25 years in Chicago. The "Long Count" between Tunney and Dempsey, in 1927, may still be the most controversial bout of all time. Chicago Boxing is a story not only of great boxers, but of the fans who embraced them, the promoters who made them big, and even a few mob bosses who made good on their talent.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.J. Johnston, Sean Curtin, David Mamet
      </h2>
      
      <p class="authorDescription body article">J.J. Johnston is best known for his roles on stage and screen. But he is also a former Chicago area amateur and a leading boxing historian and collector. He has worked behind the scenes on many boxing and crime documentaries. Together with his partner in crime, Sean Curtin, another former local fighter and now a referee, J.J. tells the story of Chicago Boxing as it could only be told by an insider.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b0f1f5da